import { z } from "zod";
export var ServiceVehicleStatus;
(function (ServiceVehicleStatus) {
    ServiceVehicleStatus["AVAILABLE"] = "AVAILABLE";
    ServiceVehicleStatus["IN_USE"] = "IN_USE";
    ServiceVehicleStatus["MAINTENANCE"] = "MAINTENANCE";
    ServiceVehicleStatus["UNAVAILABLE"] = "UNAVAILABLE";
})(ServiceVehicleStatus || (ServiceVehicleStatus = {}));
// Общая схема для ServiceVehicle
export const zServiceVehicleCommonSchema = z.object({
    id: z.string(),
    licensePlate: z.string(),
    brand: z.string(),
    model: z.string(),
    serviceIntervalKm: z.number(),
    serviceIntervalMonths: z.number(),
    currentMileageKm: z.number(),
    lastServiceDate: z.string().optional(),
    lastServiceMileageKm: z.number().nullish(),
    status: z.enum(ServiceVehicleStatus),
    maxChargeCapacity: z.number().nullish(),
    currentChargeLevel: z.number().nullish(),
    kwtperkm: z.number().nullish(),
    idCreatedBy: z.string().nullish(),
    idUpdatedBy: z.string().nullish(),
    isDeleted: z.boolean().nullish(),
});
export const zServiceVehicleFiltersSchema = z.object({
    search: z.string().optional(),
    status: z.enum(ServiceVehicleStatus).optional(),
});
